import { render } from "./PostCard.vue?vue&type=template&id=16cb88ea&scoped=true&ts=true"
import script from "./PostCard.vue?vue&type=script&lang=ts"
export * from "./PostCard.vue?vue&type=script&lang=ts"

import "./PostCard.vue?vue&type=style&index=0&id=16cb88ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cb88ea"]])

export default __exports__